import React from "react";
import { func, number } from "prop-types";
import I18n from "pages/_components/I18n";
import FilterForm from "pages/payThirdParties/_components/FilterForm";

const EmitedSideBarForm = ({ closeSidebar, positionTab }) => {
    const dateFrom = null;
    const dateTo = null;

    const initialValues = {
        dateRange: [dateFrom, dateTo],
    };

    return (
        <div className="container full-width" style={{ justifyContent: "center" }}>
            <I18n id="debin.filter" component="h2" />
            <div className="text-left">
                <FilterForm
                    isEmittedForm
                    customValues={initialValues}
                    closeSidebar={closeSidebar}
                    positionTab={positionTab}
                />
            </div>
        </div>
    );
};

EmitedSideBarForm.propTypes = {
    closeSidebar: func.isRequired,
    positionTab: number.isRequired,
};

export default EmitedSideBarForm;
